import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { useSelector, useDispatch } from 'react-redux';
import { selectServiceTimes, SET_DEFAULT_PLAN } from './reducer';
import { WeekDayKeys, WeekDayKeysKor, presentPricingModel, presentServiceTime, presentServiceType } from './functions';
import { toPriceKRW } from '../util/CommonUtils';

// const ServiceTimes TODO 
export const ServiceTimes = () => {
  
  const dispatch = useDispatch();

  const serviceTimes = useSelector(selectServiceTimes);

  const filteredServiceTimes = useMemo(
    () => serviceTimes.map(serviceTime => {
      const plans = serviceTime.servicePlan.filter(
        plan => plan.serviceTypeId === 45 || plan.serviceTypeId === 46
      );
      if (plans.length > 0) {
        return {
          ...serviceTime,
          servicePlan: plans
        }
      }
      return null;
    }).filter(el => el !== null), 
    [serviceTimes]
  )

  const setDefault = (serviceTime, servicePlan) => {
    if (serviceTime.defaultPlan?.id !== servicePlan.id) {
      dispatch({
        type: SET_DEFAULT_PLAN,
        payload: {
          serviceTime: serviceTime,
          servicePlan: servicePlan
        },
      });
    }
  }

  return (
    <Root>
      <Title>
        서비스 타임 및 플랜 정보
      </Title>
      {filteredServiceTimes.map((serviceTime, i) => (
        <ServiceTimeBox key={i} >
          <ServiceTimeTitle>
            {presentServiceTime(serviceTime.serviceTime)}
          </ServiceTimeTitle>
          <DaysBox>
            {WeekDayKeys.map((key, i) => {
              if (serviceTime[key] === true) {
                return <ActiveDay key={i}>{WeekDayKeysKor[i]}</ActiveDay>
              }
              else {
                return <InactiveDay key={i} style={{color: 'gray'}}>{WeekDayKeysKor[i]}</InactiveDay>
              }
            })}
          </DaysBox>
          <ServicePlanBox>
            {serviceTime.servicePlan.map((servicePlan, j) => (
              <ServicePlanSummary key={j}>
                <PriceBox onClick={() => { setDefault(serviceTime, servicePlan) }}>
                 {servicePlan.pricingModel === 'tiered' ? 
                  toPriceKRW(servicePlan.tierPrice) : 'N/A'}
                </PriceBox>
                <PricingModelBox>
                  &nbsp;({presentServiceType(servicePlan.serviceTypeId) + ' / ' + 
                    presentPricingModel(servicePlan.pricingModel)})
                </PricingModelBox> 
                {serviceTime.servicePlan.length > 1 && servicePlan.id === serviceTime.defaultPlan?.id && 
                  <DefaultPlanBox>&#10003; 기본 플랜</DefaultPlanBox>}
              </ServicePlanSummary>
            ))}
          </ServicePlanBox>
        </ServiceTimeBox>
      ))}
      <div>
        <small>* 현 시점 밀박스/뷔페만 표시합니다.</small>
      </div>
    </Root>
  );
}

const Root = styled.div`
  border: 1px solid #dddddd;
  margin-left: 1em;
  padding: 1em;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 15px;
`;

const ServiceTimeBox = styled.div`
  display: flex;
  margin-bottom: 1em;
`;

const ServiceTimeTitle = styled.div`
  width: 40px;
`;

const DaysBox = styled.div`

`;

const ActiveDay = styled.span`
  color: white;
  background-color: #ef62a1;
  margin-right: 0.2em;
  padding: 0.1em;
  border-radius: 0.2em;
`;

const InactiveDay = styled.span`
  color: gray;
  margin-right: 0.2em;
  padding: 0.1em;
`;

const ServicePlanBox = styled.div`

`;

const ServicePlanSummary = styled.div`

`;

const PriceBox = styled.span`
  width: 88px;
  margin-bottom: 0.2em;
  display: inline-block;
  text-align: right;
  cursor: pointer;
`;

const PricingModelBox = styled.span`
  font-size: 0.8em;
`;

const DefaultPlanBox = styled.span`
  font-size: 0.8em;
  margin-left: 1em;
  color: #ef62a1;
`;